import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';

class ManageContainerState {
  store = new DomainStore();
  history;
  agent;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false,
      agent: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  setInteractiveAgent(agent) {
    this.agent = agent;
  }

  async createPolicy() {
    const {model} = await this.store.post(
      endpoints.EXPENSES.POLICIES.ALL,
      types.EXPENSES.POLICY
    );

    this.history.push(`/manage/policies/${model.id}/edit`);
  }

  async removePolicy(policy) {
    await this.store.destroy(policy);
    await this.agent.refresh();
  }
}

export default ManageContainerState;
